// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialLeave = () => {
  const item = window.sessionStorage.getItem("leave");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const getLeave = createAsyncThunk(
  "leave/getLeave",
  async (obj, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_HR_API}leave-request`,
        {
          params: { branch: obj.branch },
          headers: { Authorization: `Bearer ${obj.token}` },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const leaveSlice = createSlice({
  name: "leave",
  initialState: {
    leaveData: initialLeave(),
  },

  extraReducers: (builder) => {
    builder
      .addCase(getLeave.fulfilled, (state, action) => {
        state.leaveData = action.payload;
        sessionStorage.setItem("leave", JSON.stringify(action.payload));
        // state.bookmarks = action.payload.bookmarks
      })
      .addCase(getLeave.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Store error message
      });
  },
});

export default leaveSlice.reducer;
